const requestFilesById = new Map();

export const setRequestFiles = (requestId, { attachments = [], file = null } = {}) => {
  requestFilesById.set(requestId, {
    attachments: attachments.filter(Boolean),
    file: file || null,
  });
};

export const getRequestFiles = (requestId) => {
  return requestFilesById.get(requestId) ?? { attachments: [], file: null };
};

export const clearAllRequestFiles = () => {
  requestFilesById.clear();
};
